import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "mp-pinned-shades";
export const MAX_PINS = 6;

const read = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.debug("Pinned shades unreadable, starting empty:", e);
    return [];
  }
};

export const pinKey = (colourNumber, qualityId) => `${colourNumber}-${qualityId}`;

export function usePinnedShades() {
  const [pinned, setPinned] = useState(read);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(pinned));
    } catch (e) {
      // storage blocked — pins stay for this session only
      console.debug("Pinned shades could not be persisted:", e);
    }
  }, [pinned]);

  const togglePin = useCallback((item) => {
    setPinned((prev) => {
      const exists = prev.some((p) => p.key === item.key);
      if (exists) return prev.filter((p) => p.key !== item.key);
      if (prev.length >= MAX_PINS) return [...prev.slice(1), item];
      return [...prev, item];
    });
  }, []);

  const unpin = useCallback((key) => setPinned((prev) => prev.filter((p) => p.key !== key)), []);
  const clearPins = useCallback(() => setPinned([]), []);

  return { pinned, togglePin, unpin, clearPins, isFull: pinned.length >= MAX_PINS };
}
